import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { CMTableList } from '../../components/common/TableList/TableList';
import { PageRoutes } from '../../constants';
import { AppContext } from '../../components/common/Helpers/Context/AppContext';
import { deleteLab, labStatus, listLab } from './LabServices';

const LabList = () => {

    const { globalData, setGlobalData } = React.useContext(AppContext);

    const columns: readonly any[] = [
        { key: "patient_id", label: "Patient ID", minWidth: 170 }, 
        
    ];

    React.useEffect(() => {
        setGlobalData({
            ...globalData,
            loading: true
        })
        listLab().then((res: any) => {
            setGlobalData({
                ...globalData,
                loading: false
            })
        }).catch((err: any) => {
            console.log(err)
            setGlobalData({
                ...globalData,
                loading: false,
                error: true,
                errorMessage: "Failed to load data"
            });
        })
    }, [])
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <PageHeader header='Lab' list={true} link={PageRoutes.LAB_ADD} value={"Add Lab"} />
                            <CMTableList
                                blockService={labStatus}
                                listService={listLab}
                                deleteService={deleteLab}
                                // deleteHardService={deleteLab}
                                showView={false}
                                showBlock={false}
                                columns={columns}
                                deleteAccess={true}
                                editAccess={true}
                                editLink={PageRoutes.LAB_EDIT}
                            />
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default LabList;

